import jApi from './jApi';

export default {
  // Data Siswa -----------------------------------
  getListSiswa(req) {
    const api = jApi.generateApi();
    return api.post('siswa/list', req)
      .then(res => res);
  },

  createSiswa(req) {
    const api = jApi.generateApi();
    return api.post('siswa/create', req)
      .then(res => res);
  },

  updateSiswa(req) {
    const api = jApi.generateApi();
    return api.post('siswa/update', req)
      .then(res => res);
  },

  deleteSiswa(req) {
    const api = jApi.generateApi();
    return api.post('siswa/delete', req)
      .then(res => res);
  },

  detailSiswa(req) {
    const api = jApi.generateApi();
    return api.post('siswa/detail', req)
      .then(res => res);
  },

  changePasswdSiswa(req) {
    const api = jApi.generateApi();
    return api.post('siswa/change-password', req)
      .then(res => res);
  },

  // Buku Saku Siswa -----------------------------------
  listTahunAjaran(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/list', req)
      .then(res => res);
  },

  listKelas(req) {
    const api = jApi.generateApi();
    return api.post('kelas/list', req)
      .then(res => res);
  },

  listKelasLulusan(req) {
    const api = jApi.generateApi();
    return api.post('kelas/list-12', req)
      .then(res => res);
  },

  listKelasAll(req) {
    const api = jApi.generateApi();
    return api.post('kelas/list-all', req)
      .then(res => res);
  },

  listKelasByTahun(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/kelas/list', req)
      .then(res => res);
  },

  listSiswaByKelas(req) {
    const api = jApi.generateApi();
    return api.post('siswa/list-by-kelas', req)
      .then(res => res);
  },

  // Additional Info
  getAdditionalInfo(req) {
    const api = jApi.generateApi();
    return api.get(`document/category/additional-info/list/${req}`)
      .then(res => res);
  },

  // Prestasi & Pelanggaran
  getListDocument(req) {
    const api = jApi.generateApi();
    return api.post('kesiswaan/document/list', req)
      .then(res => res);
  },

  createDocument(req) {
    const api = jApi.generateApi();
    return api.post('kesiswaan/document/create', req)
      .then(res => res);
  },

  updateDocument(req) {
    const api = jApi.generateApi();
    return api.post('kesiswaan/document/update', req)
      .then(res => res);
  },

  detailDocument(req) {
    const api = jApi.generateApi();
    return api.post('kesiswaan/document/detail', req)
      .then(res => res);
  },

  deleteDocument(req) {
    const api = jApi.generateApi();
    return api.post('kesiswaan/document/delete', req)
      .then(res => res);
  },

  submitDocument(req) {
    const api = jApi.generateApi();
    return api.post('kesiswaan/document/submit', req)
      .then(res => res);
  },

  getListDocumentApp(req) {
    const api = jApi.generateApi();
    return api.post('kesiswaan/document/approver/list', req)
      .then(res => res);
  },

  approveDocument(req) {
    const api = jApi.generateApi();
    return api.post('kesiswaan/document/approver/approve', req)
      .then(res => res);
  },

  rejectDocument(req) {
    const api = jApi.generateApi();
    return api.post('kesiswaan/document/approver/reject', req)
      .then(res => res);
  },

  // Data Ekskul -----------------------------------
  getListEkskul(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/list', req)
      .then(res => res);
  },

  createEkskul(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/create', req)
      .then(res => res);
  },

  updateEkskul(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/update', req)
      .then(res => res);
  },

  deleteEkskul(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/delete', req)
      .then(res => res);
  },

  detailEkskul(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/detail', req)
      .then(res => res);
  },

  getListAgenda(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/absen/agenda/list', req)
      .then(res => res);
  },

  createAgenda(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/absen/agenda/create', req)
      .then(res => res);
  },

  updateAgenda(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/absen/agenda/update', req)
      .then(res => res);
  },

  deleteAgenda(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/absen/agenda/delete', req)
      .then(res => res);
  },

  getListPembina(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/pembina/list', req)
      .then(res => res);
  },

  createPembina(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/pembina/create', req)
      .then(res => res);
  },

  updatePembina(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/pembina/update', req)
      .then(res => res);
  },

  deletePembina(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/pembina/delete', req)
      .then(res => res);
  },

  getListAnggota(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/siswa/list', req)
      .then(res => res);
  },

  createAnggota(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/siswa/create', req)
      .then(res => res);
  },

  updateAnggota(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/siswa/update', req)
      .then(res => res);
  },

  deleteAnggota(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/siswa/delete', req)
      .then(res => res);
  },

  insertAbsen(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/absen/insert', req)
      .then(res => res);
  },

  listAbsen(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/absen/list', req)
      .then(res => res);
  },

  updateAbsen(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/absen/update', req)
      .then(res => res);
  },

  insertNilai(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/nilai/insert', req)
      .then(res => res);
  },

  listNilai(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/nilai/list', req)
      .then(res => res);
  },

  updateNilai(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/nilai/update', req)
      .then(res => res);
  },

  // Tahun Ajaran
  createTahunAjaran(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/create', req)
      .then(res => res);
  },

  updateTahunAjaran(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/update', req)
      .then(res => res);
  },

  deleteTahunAjaran(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/delete', req)
      .then(res => res);
  },

  // Kelas
  createKelas(req) {
    const api = jApi.generateApi();
    return api.post('kelas/create', req)
      .then(res => res);
  },

  updateKelas(req) {
    const api = jApi.generateApi();
    return api.post('kelas/update', req)
      .then(res => res);
  },

  deleteKelas(req) {
    const api = jApi.generateApi();
    return api.post('kelas/delete', req)
      .then(res => res);
  },

  // Bagi Kelas
  listBagiKelas(req) {
    const api = jApi.generateApi();
    return api.post('siswa/bagi-kelas/list', req)
      .then(res => res);
  },

  createBagiKelas(req) {
    const api = jApi.generateApi();
    return api.post('siswa/bagi-kelas/create', req)
      .then(res => res);
  },

  updateBagiKelas(req) {
    const api = jApi.generateApi();
    return api.post('siswa/bagi-kelas/update', req)
      .then(res => res);
  },

  deleteBagiKelas(req) {
    const api = jApi.generateApi();
    return api.post('siswa/bagi-kelas/delete', req)
      .then(res => res);
  },

  // Wali Kelas
  listWaliKelas(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/walikelas/list', req)
      .then(res => res);
  },

  createWaliKelas(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/walikelas/create', req)
      .then(res => res);
  },

  updateWaliKelas(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/walikelas/update', req)
      .then(res => res);
  },

  deleteWaliKelas(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/walikelas/delete', req)
      .then(res => res);
  },

  // Poin
  listPoin(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/master-point/list', req)
      .then(res => res);
  },

  createPoin(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/master-point/create', req)
      .then(res => res);
  },

  updatePoin(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/master-point/update', req)
      .then(res => res);
  },

  deletePoin(req) {
    const api = jApi.generateApi();
    return api.post('tahunajaran/master-point/delete', req)
      .then(res => res);
  },

  // Pelanggaran
  listPelanggaran() {
    const api = jApi.generateApi();
    return api.get('pelanggaran/list')
      .then(res => res);
  },

  createPelanggaran(req) {
    const api = jApi.generateApi();
    return api.post('pelanggaran/create', req)
      .then(res => res);
  },

  updatePelanggaran(req) {
    const api = jApi.generateApi();
    return api.post('pelanggaran/update', req)
      .then(res => res);
  },

  deletePelanggaran(req) {
    const api = jApi.generateApi();
    return api.post('pelanggaran/delete', req)
      .then(res => res);
  },

  getListTahunEkskul(req) {
    const api = jApi.generateApi();
    return api.post('ekskul/list-per-tahunajaran', req)
      .then(res => res);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiKesiswaan.js